module.exports = __webpack_public_path__ + "static/img/img51.9f7f174.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img51.png
// module id = xy1Y
// module chunks = 1